import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SplashScreenService } from '../common/splash-screen.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements AfterViewInit {
  constructor(private splashScreenService: SplashScreenService) {}
  ngAfterViewInit() {
    this.splashScreenService.hide();
  }
}
